import { z } from 'zod';
export const PrincipalName = z.string().min(1).max(64).regex(/^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/).refine(s => !s.endsWith('-'));
export const TargetSpecKind = ['by-hub-id', 'by-handle'];
export const RemoteByHubId = z.object({ kind: z.literal('by-hub-id'), hubId: z.string().uuid() });
export const RemoteByHandle = z.object({ kind: z.literal('by-handle'), owner: z.string().min(1).max(128).regex(/^[a-z0-9][a-z0-9_-]*$/), principalName: PrincipalName });
export const TargetSpec = z.discriminatedUnion('kind', [RemoteByHubId, RemoteByHandle]);
export function formatTargetSpecPath(spec) { return spec.kind === 'by-hub-id' ? spec.hubId : `${spec.owner}/${spec.principalName}`; }
export function parseTargetSpecPath(path) {
    const direct = RemoteByHubId.safeParse({ kind: 'by-hub-id', hubId: path });
    if (direct.success)
        return direct.data;
    const parts = path.split('/');
    if (parts.length !== 2)
        return null;
    const handle = RemoteByHandle.safeParse({ kind: 'by-handle', owner: parts[0], principalName: parts[1] });
    return handle.success ? handle.data : null;
}
//# sourceMappingURL=target-spec.js.map